// extracted by mini-css-extract-plugin
module.exports = {"warn":"style_warn__2dihv","info":"style_info__1EcfD","center":"style_center__-xHEh","imageBox":"style_imageBox__1FjbF"};